import { Account } from "~/bff/types/Account";

import { setStoreToCookies } from "./set-store-to-cookies";

export const cleanUpSelectedStore = (account?: Account): void => {
  if (account?.selectedStore) {
    setStoreToCookies(account.selectedStore);
  }
};
